module.exports = "<aside class=\"kl-aside\" r-style={ { width: width } } r-class={ {'is-active': active } }>\n    {#inc this.$body}\n\n  {#if showFold}\n  <div class=\"kl-sidebar-btn-wrap\" on-click=\"{this.toggle($event)}\" r-style={{ left: width }}>\n    {#if active}\n    <i class=\"kl-icon kl-icon-chevron_left\"></i>\n    <kl-icon fontSize=12 type=\"arrow-left\" />\n    {#else}\n    <kl-icon fontSize=12 type=\"arrow-right\" />\n    {/if}\n  </div>\n  {/if}\n</aside>\n"


//////////////////
// WEBPACK FOOTER
// ../src/js/components/layout/KLLayout/KLAside/index.html
// module id = 569
// module chunks = 0